export const actionOptions = {
  // THIS IS ONLY FOR TESTING PURPOSES INSIDE THE COMPONENT, NOT MEANT TO INDICATE WHAT SHOULD BE USED IN PRODUCTION
  // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
  "all": [
    {
      title: "Cancel",
      cls: "bulk-cancel-asn",
      icon: "paper-plane-o",
      disabled:true
    }
  ],
  "actions": [
    {
      title: "Cancel",
      cls: "cancel-asn",
      icon: "ban",
      disabled:false
    },
    {
      title: "Edit",
      cls: "edit-asn",
      icon: "pencil",
      disabled:false
    }
  ]
};


// WEBPACK FOOTER //
// ./src/pages/asns/filter/actionOptions.js